"use strict"
/**
 *
 * To customize the drop-down list, it is enough for the select element to set the date attribute data-custom-select
 * The placeholder is simulated by the first option of the select, with an empty value
 *
 * */
window.addEventListener('DOMContentLoaded', function() {
  initCustomSelect();
});

function initCustomSelect() {
  const selectElements = document.querySelectorAll('select[data-custom-select]');

  if (selectElements.length === 0) {
    return null;
  }

  selectElements.forEach(function (element) {

    if (element.parentElement.classList.contains('c-custom-select')) {
      return;
    }

    let numberOfOptions = element.childElementCount,
      context           = element.previousElementSibling ?? element.parentElement,
      contextNext       = element.nextElementSibling ?? element.parentElement,
      prevFlag          = !!element.previousElementSibling ?? !!element.parentElement,
      nextFlag          = !!element.nextElementSibling ?? !!element.parentElement,
      form              = element.closest('form') ?? document.getElementById(element.getAttribute('form'));

    const elWithWrapper = document.createElement('div'),
      selectedItem      = document.createElement('div'),
      listElement       = document.createElement('ul'),
      selectedItemInput = document.createElement('input');

    if (typeof element.dataset.selectInput !== 'undefined') {
      selectedItemInput.setAttribute('type', 'number');
      selectedItemInput.setAttribute('min', '1');
      selectedItemInput.setAttribute('max', '99');
      selectedItemInput.setAttribute('step', '1');
      selectedItemInput.classList.add('c-custom-select__selected-input');
      selectedItemInput.value = element.children[0].textContent;
    }

    listElement.classList.add('c-custom-select__list');
    selectedItem.classList.add('c-custom-select__selected-item');

    if (typeof element.dataset.selectInput !== 'undefined') {
      selectedItemInput.value = element.children[0].textContent;
    } else {
      selectedItem.textContent = element.children[0].textContent;
    }

    if (element.classList.length > 0) {
      elWithWrapper.classList = element.classList;
      element.removeAttribute('class');
    } else {
      elWithWrapper.classList.add('c-custom-select');
    }

    elWithWrapper.appendChild(element);

    if (typeof element.dataset.selectInput !== 'undefined') {
      selectedItem.append(selectedItemInput);
    }

    element.after(selectedItem);
    selectedItem.after(listElement);

    for (let i = 0; i < numberOfOptions; i++) {

      let item = document.createElement('li');

      item.textContent = element.children[i].textContent;
      item.setAttribute('rel', element.children[i].value !== '' ? element.children[i].value : 'hide');
      item.classList.add('c-custom-select__item');
      listElement.append(item);

      if (element.children[i].hasAttribute('style')) {
        item.setAttribute('style', 'display:none')
      }

      if (element.children[i].value !== '' && (element.children[i].hasAttribute('selected') || element.children[i].value === element.value)) {
        item.classList.add('is-selected');
      }
    }

    if (typeof element.dataset.selectInput !== 'undefined') {
      if (element.value !== '' && element.querySelector('[selected]')) {
        selectedItemInput.value = element.querySelector('[selected]').textContent;
      } else if (element.value === '') {
        elWithWrapper.classList.add('is-default');
      } else {
        let validString = element.value;
        if (validString.includes('"')) {
          validString = element.value.replace('"', '\\"');
        }
        selectedItemInput.value = element.querySelector('option[value="' + validSelector + '"]').textContent;
      }
    } else {
      if (element.value !== '' && element.querySelector('[selected]')) {
        selectedItem.textContent = element.querySelector('[selected]').textContent;
      } else if (element.value === '') {
        elWithWrapper.classList.add('is-default');
      } else {
        let validString = element.value;
        if (validString.includes('"')) {
          validString = element.value.replace('"', '\\"');
        }
        selectedItem.textContent = element.querySelector('option[value="' + validString + '"]').textContent;
      }
    }

    if (prevFlag) {
      context.after(elWithWrapper);
    } else if (nextFlag) {
      contextNext.before(elWithWrapper);
    } else {
      context.append(elWithWrapper);
    }

    selectedItem.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      const stickyElement = elWithWrapper.closest('[data-sticky]');

      elWithWrapper.classList.toggle('is-active');

      if (stickyElement && stickyElement.classList.contains('sticky')) {
        document.querySelector('body').classList.toggle('active-select');
      }
      closeOther(element.id);
    });

    listElement.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (typeof element.dataset.selectInput !== 'undefined') {
        selectedItemInput.value = event.target.textContent;
      } else {
        selectedItem.textContent = event.target.textContent;
      }

      elWithWrapper.classList.remove('is-active');
      elWithWrapper.classList.remove('is-default');
      document.querySelector('body').classList.remove('active-select');

      if (typeof element.dataset.selectInput !== 'undefined') {
        element.value = selectedItemInput.value;
      } else {
        element.value = event.target.getAttribute('rel');
      }

      element.dispatchEvent(new Event("change", {bubbles: true}));

      for (let item of this.children) {
        item.classList.remove('is-selected');
      }

      event.target.classList.add('is-selected');

      if (form) {
        form.dispatchEvent(new Event("input"));
      }
    });

    selectedItemInput.addEventListener('keyup', function (event) {

      if (parseInt(selectedItemInput.value) > 99) {
        selectedItemInput.value = "99";
      }

      element.value = selectedItemInput.value;
      element.dispatchEvent(new Event("change", {bubbles: true}));
      if (form) {
        form.dispatchEvent(new Event("input"));
      }
    });

    function closeOther (elementId) {
      Array.from(selectElements).map(function (element) {
        if (element.id !== elementId) {
          element.parentElement.classList.remove('is-active');
        }
      });

      let dataOpener = document.querySelectorAll('[data-opener]');
      let dataOpenerBody = document.querySelectorAll('[data-opener-body]');

      if (dataOpener && dataOpenerBody) {
        dataOpenerBody.forEach(element => {
          element.classList.remove('is-open')
        });
        dataOpener.forEach(element => {
          element.classList.remove('is-open')
        });
      }
    }

    document.addEventListener('click', function () {
      document.querySelector('body').classList.remove('active-select');
      Array.from(selectElements).map(function (element) {
        element.parentElement.classList.remove('is-active');
      });
    });
  });
}
